(function () {
  'use strict';

  const PDP_ADDONS_STORAGE_KEY = 'customization3d_pdp_addons';
  const C3D_SDK_URL = (typeof window.CUSTOMIZATION_3D_SDK_URL === 'string' && window.CUSTOMIZATION_3D_SDK_URL.trim())
    ? window.CUSTOMIZATION_3D_SDK_URL.trim()
    : 'https://spaces.miradoroutdoor.com/sdk/index.global.js?v=123456';
  let sdkPreloadStarted = false;

  function preloadC3dSdk() {
    if (sdkPreloadStarted) return;
    sdkPreloadStarted = true;
    if (document.querySelector('script[data-c3d-sdk], script[src*="index.global.js"]')) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = C3D_SDK_URL;
    document.head.appendChild(link);
  }

  function parseSlotInput(input) {
    const v = (input.value || '').trim();
    if (!v) return null;
    const parts = v.split(':');
    const variantId = (parts[0] || '').trim();
    const quantity = parseInt(parts[1], 10);
    const productId = (parts[2] || '').trim();
    const productHandle = input.getAttribute('data-product-handle') || '';
    if (!variantId) return null;
    return {
      variantId,
      quantity: !Number.isNaN(quantity) && quantity > 0 ? quantity : 1,
      productId: productId || undefined,
      productHandle: productHandle || undefined,
    };
  }

  function collectPdpAddonSelections() {
    const accessories = [];
    const sidewalls = [];
    document.querySelectorAll('input[name="accessories[]"]').forEach((input) => {
      const row = parseSlotInput(input);
      if (row) accessories.push(row);
    });
    document.querySelectorAll('input[name="sidewalls[]"]').forEach((input) => {
      const row = parseSlotInput(input);
      if (row) sidewalls.push(row);
    });
    return { accessories, sidewalls };
  }

  function persistAddonsForCustomizationPage() {
    try {
      const data = collectPdpAddonSelections();
      if (!data.accessories.length && !data.sidewalls.length) {
        sessionStorage.removeItem(PDP_ADDONS_STORAGE_KEY);
        return;
      }
      sessionStorage.setItem(
        PDP_ADDONS_STORAGE_KEY,
        JSON.stringify({
          v: 1,
          accessories: data.accessories,
          sidewalls: data.sidewalls,
          at: Date.now(),
        })
      );
    } catch (e) {
      console.warn('[product-3d-customization-link] persist addons', e);
    }
  }

  function init() {
    const link = document.querySelector('[data-customization-3d-link]');
    if (!link) return;

    const formId = link.getAttribute('data-form-id');
    const form = formId ? document.getElementById(formId) : null;
    const baseUrl = link.getAttribute('data-base-url');
    const productId = link.getAttribute('data-product-id');
    const productHandle = link.getAttribute('data-product-handle') || '';

    if (!form || !baseUrl || !productId) return;

    const warmSdk = () => preloadC3dSdk();

    link.addEventListener('pointerenter', warmSdk, { passive: true });
    link.addEventListener('focus', warmSdk);
    link.addEventListener('pointerdown', () => {
      warmSdk();
      persistAddonsForCustomizationPage();
    }, true);

    const sync = () => {
      const idInput = form.querySelector('[name="id"]');
      const variantId = idInput?.value;
      if (!variantId) return;

      try {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('variant', variantId);
        url.searchParams.set('product_id', productId);
        if (productHandle) {
          url.searchParams.set('handle', productHandle);
        } else {
          url.searchParams.delete('handle');
        }
        link.setAttribute('href', url.toString());
      } catch (e) {
        console.warn('[product-3d-customization-link]', e);
      }
    };

    form.addEventListener('variant:change', sync);
    form.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id') sync();
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
